import React from "react";

const home = () => {
  return (
    <div>
      <h1 style={{ color: " var(--primaryText)" }}>Welcome to Recipe Book!</h1>
      <a href="https://github.com/suseendharlal96/recipe-react">
        Github for recipe
      </a>
    </div>
  );
};

export default home;
